import appNavItemTypeCheckers from '../../types/appNavItemTypeCheckers';

const getScorecardIdsInApp = ({ app }: { app: V3.App }) => {
  try {
    return app.navigationSettings.sections.reduce((acc, section) => {
      const sectionIds = section.items.reduce((itemAcc, item) => {
        if (appNavItemTypeCheckers.isScorecard(item)) {
          return [...itemAcc, item.scorecardId];
        }
        if (appNavItemTypeCheckers.isScorecardsIndex(item)) {
          return [...itemAcc, ...item.scorecardIds];
        }
        if (appNavItemTypeCheckers.isAllAssets(item)) {
          return [...itemAcc, ...item.scorecards.map((s) => s.id)];
        }
        return itemAcc;
      }, [] as string[]);

      return [...acc, ...sectionIds];
    }, [] as string[]);
  } catch (e) {
    return [];
  }
};

export default getScorecardIdsInApp;
